<div class="page-container">
  <!-- Header Section -->
  <ion-card class="page-card">
    <ion-card-content>
      <h2 class="page-title">
        <ion-icon name="help-circle-outline" class="title-icon"></ion-icon>
        <span>{{ 'Help Pages' | translate }}</span>
      </h2>
      <div class="subtitle">{{ 'Help & Support' | translate }}</div>
    </ion-card-content>
  </ion-card>
</div>
<div id="desktop">
  <ion-item  lines="none" color="none">
    <ion-searchbar class="search" placeholder="{{ 'Search for help pages' | translate }}" (ionInput)="onSearch($event)"></ion-searchbar>
  </ion-item>
  <ion-grid>
    <ion-row class="ion-justify-content-start">
      @for (helpPage of helpPageList; track helpPage) {
        <ion-col size-xs="12" size-sm="6" size-md="6" size-lg="6" size-xl="6">
          <ion-card class="help-card">
            <div [routerLink]="['../help-pages-detail/' + helpPage.HelpPageID]">
              <ion-grid style="margin: 10px;">
                <ion-row>
                  <ion-col [size]="helpPage.Pinned ? 10.5 : 12">
                    @if (isPublicLogoUrl(helpPage.TitleImageURL)) {
                      <div style="height: 15em; overflow: hidden; background-position: center center; background-size: contain; background-repeat: no-repeat;"
                        [style.background-image]="'url(' + helpPage.TitleImageURL + ')'" class="card-image">
                      </div>
                    } @else {
                      @if (helpPage.TitleImageURL | secureBlob | async; as bgUrl) {
                        <div style="height: 15em; overflow: hidden; background-position: center center; background-size: contain; background-repeat: no-repeat;"
                          [style.background-image]="'url(' + getBackgroundUrl(bgUrl) + ')'"
                          class="card-image">
                        </div>
                      } @else {
                        <div style="height: 15em; overflow: hidden; background-position: center center; background-size: contain; background-repeat: no-repeat; background-image: url(../assets/no_image.png);"
                          class="card-image">
                        </div>
                      }
                    }
                  </ion-col>
                  <ion-col size="1.5">
                    @if (helpPage.Pinned) {
                      <ion-icon class="pinned-icon" name="bookmarks-outline" ></ion-icon>
                    }
                  </ion-col>
                </ion-row>
              </ion-grid>
              <ion-card-header class="custom-card-header">
                <ion-title class="custom-card-title">{{helpPage.Title}}</ion-title>
              </ion-card-header>
              <ion-card-content class="custom-card-content">
                <div
                  class="text description-ellipsis"
                  [attr.title]="helpPage.Description.length > 90 ? helpPage.Description : null">
                  {{helpPage.Description}}
                </div>
              </ion-card-content>
            </div>
            <ion-footer>
              <div class="card-footer">
                @for (section of helpPage.Sections; track section; let i = $index) {
                  <div>
                    @if (i<3) {
                      <ion-button (click)="redirectSection(section)">{{section.Title?.length > 14 ? section.Title.substring(0,14) : section.Title}}</ion-button>
                    }
                  </div>
                }
              </div>
              @if (helpPage.Sections.length === 0) {
                <div class="card-footer-empty">
                </div>
              }
            </ion-footer>
          </ion-card>
        </ion-col>
      }
    </ion-row>
  </ion-grid>

  @if (showLoadingHelpPages) {
    <ion-spinner name="circular" class="spinner"></ion-spinner>
  }

</div>
<!-- Return footer -->
<div class="dashboard-return-footer">
  <span class="dashboard-footer-line"></span>
  <ion-button routerLink="/home" color="secondary" class="dashboard-return-btn">
    <ion-icon name="arrow-back-outline" slot="start"></ion-icon>
    {{'Return' | translate}}
  </ion-button>
  <span class="dashboard-footer-line"></span>
</div>
